import { isWithinInterval } from 'date-fns';

export const timeIsBetween = (
  time: Date,
  startTime: Date,
  endTime: Date
): boolean => isWithinInterval(time, { start: startTime, end: endTime });
